export const SETSOURCEENQUIRYLIST = "SETSOURCEENQUIRYLIST";
export const SETENQUIRYLIST = "SETENQUIRYLIST";
export const SETENQUIRYLISTBYID = "SETENQUIRYLISTBYID";
export const SETENQUIRYCUSTOMERLIST = "SETENQUIRYCUSTOMERLIST";
export const SETCATEGORY = "SETCATEGORY";
export const SETENQUIRYCOUNT = "SETENQUIRYCOUNT";
export const SETENQUIRYCOMMENTS = "SETENQUIRYCOMMENTS";
export const SETENQUIRYFOLLWUPHISTORY = "SETENQUIRYFOLLWUPHISTORY";
export const SETENQUIRYATTACHMENTDATA = "SETENQUIRYATTACHMENTDATA";
